import isEmpty from "lodash/isEmpty";
import React from "react";
import { useForm } from "react-hook-form";

import { addFileTags } from "../../../../services/documents.service";
import { fileExtension } from "../../../../utils/helpers/misc.helper";
import { DocFile, Error } from "../../../../utils/types/documents.type";
import { DocumentsState, } from "../../types";

export type TagType = "investor" | "fund" | "quarter";

type Tags = {
  investor?: string;
  funds?: string[];
  quarter?: string;
  selectedTags: Array<TagType>;
};


const useAddTags = (state: DocumentsState | null, props : any) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
    reset,
    watch,
    setError
  } = useForm<Tags>({
    // resolver,
    defaultValues: {
      funds: [],
      investor: "",
      quarter: "",
      selectedTags: [],
    },
  });

  const resetForm = () => {
    setLoading(false);
    reset();
  };

  const onReview = (data: any, files: DocFile[], handleClose: Function): void => {
    setLoading(true);
    const errorProneFiles: Array<Error> = [];
    const { investor, funds, quarter } = data;
    const tagFields = {
      investorIds: investor === "all" ? state?.availableOptions.investors.map(investor => investor.id): investor ? [investor] : [],
      fundIds: funds,
      quarterId: quarter,
    };
    
    const fileParams = {
      fileIds: files.map(file => file.id),
      ...tagFields
    };

    if(state?.currentFolder?.id) {
      addFileTags({
        folderId: state.currentFolder.id,
        ...fileParams
      }).then((res: any) => {
        setLoading(false);
        if(!isEmpty(res.failedFiles)) {
          //handle error
          for(const i in res.failedFiles) {
            errorProneFiles.push({
              id: i,
              label: i,
              errorMsg: res.failedFiles[i],
              iconType: fileExtension(i),
            });
          }
          props.setErrors(errorProneFiles);
          resetForm();
          handleClose();
          return;
        }
        resetForm();
        handleClose();
      }).catch(err => {
        setLoading(false);
        if(err) {
          // handle error
        }
      });
    } else {
      setLoading(false);
    }
  };

  const handleCheck = (tag: TagType): Array<TagType> => {
    const { selectedTags } = getValues();

    for(const curTag of selectedTags) {
      if(curTag === tag) {
        return selectedTags.filter(item => item !== curTag);
      }
    }
    return [...selectedTags, tag];
  };

  const getInvestors = (): Array<any>  => state?.availableOptions.investors.map(investor => ({ label: investor.name, value: investor.id })) ?? [];
  const getFunds = (): Array<any>  => state?.availableOptions.funds ?? [];
  const getQuarters = (): Array<any>  => state?.availableOptions.quarters.map(quarter => ({ label: quarter.name, value: quarter.id })) ?? [];

  return {
    loading,
    register,
    errors,
    control,
    handleSubmit,
    handleCheck,
    onReview,
    getInvestors,
    getFunds,
    getQuarters,
    getValues,
    setValue,
    resetForm,
    reset,
    watch,
  };
};

export default useAddTags;